<template>
  <div class="achievements">
    <AppBar />
    <div class="page-content">
      <div class="achievements-canvas">
        <div class="achievements-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
            <div class="solution-btn" @click="openBealter">预约演示</div>
          </div>
        </div>
      </div>
      <div ref="nav" class="achievements-nav">
        <div
          ref="navTabs"
          class="achievements-nav-tabs"
          :style="{ width: navWidth + '%', height: navHeight + 'px' }"
        >
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="[
              'achievements-nav-item',
              topNaviId === item.id ? 'top-nav-item' : '',
            ]"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div>
        <div ref="product-value" class="product-value">
          <div class="title-subtitle">
            <div class="title">产品价值分析</div>
          </div>
          <div class="value-list">
            <div
              v-for="(item, index) in valueList"
              :key="index"
              class="value-list-item"
            >
              <div class="value-list-item-card">
                <div class="list-item-icon-wrap">
                  <img :src="item.icon" alt="" class="list-item-icon" />
                </div>
                <div class="list-item-text">
                  <div class="list-item-title">
                    {{ item.title }}
                  </div>
                  <div class="list-item-des">
                    <div
                      v-for="(textItem, textindex) in item.describeList"
                      :key="textindex"
                      class="list-item-des-item"
                    >
                      {{ textItem }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="architecture" class="architecture">
          <div class="title">系统流程图</div>
          <div class="architecture-content">
            <img :src="architecture" alt="" />
          </div>
        </div>
      </div>
      <div>
        <div ref="introduction" class="introduction">
          <div class="title">系统功能介绍</div>
          <div class="introduction-tag-list">
            <div
              v-for="(item, index) in introductionTagList"
              :key="index"
              class="tag-list-item"
              :class="{'tag-list-item-change': introductionIndex == index}"
            >
              <div class="tag-list-text" @click="changeIndex(item)">
                {{ item.text }}
              </div>
            </div>
          </div>
          <div class="introduction-content-box">
            <transition name="introduction-contents">
              <div v-if="introductionList.length != 0" :key="introductionIndex" class="introduction-content">
                <div class="introduction-content-left">
                  <div class="content-title">{{ introductionList[introductionIndex].title }}</div>
                  <div
                    v-for="(item, index) in introductionList[introductionIndex].content"
                    :key="index"
                    class="content-text-box"
                  >
                    <div class="content-text-li"></div>
                    <div class="content-text">{{ item }}</div>
                  </div>
                </div>
                <div class="introduction-content-right">
                  <img :src="introductionList[introductionIndex].img" alt="" />
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div>
        <div style="background-color: #f7f9fc; padding-top: 40px">
          <div ref="data-security" class="data-security">
            <div class="title">数据安全</div>
            <div class="data-security-tag">
              <div
                v-for="(item, index) in dataSecurityTagList"
                :key="index"
                class="data-security-tag-item"
              >
                <div class="item-box" @click="changeStep(index)">
                  <div
                    class="item-icon"
                    :class="{
                      'item-icon-active':
                        item.index === dataSecurityTagActiveIndex,
                    }"
                  >
                    <img :src="item.url" alt="" />
                  </div>
                  <div class="item-title">{{ item.title }}</div>
                </div>
                <div v-if="index < 2" class="data-security-tag-arrow"></div>
              </div>
            </div>
            <div class="data-security-content">
              <div class="arrow" @click="last">
                <img
                  :src="require('@/assets/personnelgrow/icon/left-arrow.png')"
                  alt=""
                />
              </div>
              <transition name="secrity-fade" mode="out-in">
                <div
                  v-if="dataSecurityList.length != 0"
                  :key="dataSecurityTagActiveIndex"
                  class="data-security-content-list"
                >
                  <div class="data-security-content-left">
                    <img
                      :src="dataSecurityList[dataSecurityTagActiveIndex].url"
                      alt=""
                    />
                  </div>
                  <div class="data-security-content-right">
                    <div
                      v-for="(item, index) in dataSecurityList[
                        dataSecurityTagActiveIndex
                      ].textList"
                      :key="index"
                      class="content-text-box"
                    >
                      <img
                        :src="require('@/assets/home/content-tip.png')"
                        alt=""
                        class="list-icon"
                      />
                      <div class="text">
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <div class="arrow" @click="next">
                <img
                  :src="require('@/assets/personnelgrow/icon/right-arrow.png')"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="customer-stories">
          <div style="width: 100%; height: 60px; background-color: #f7f9fc;"></div>
          <div class="customer-stories">
            <div class="customer-stories-content">
              <div class="title">中大型企业的共同选择</div>
              <div class="customer-stories-list">
                <div v-for="(item, index) in enterpriseList" :key="index" class="cystiner-stirues-item">
                  <img :src="item" alt="" />
                </div>
              </div>
              <div class="customer-stories-btn" @click="moreEnterprise">
                <div class="btn-text">
                  查看更多案例
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="data-download" class="data-download">
          <div class="title">行业资料</div>
          <div class="data-download-content">
            <div v-for="(item, index) in dataDownloadList" :key="index" class="data-download-content-item">
              <div class="item-title-box">
                <img :src="item.img" alt="" class="background" />
                <div class="eng_title">{{ item.eng }}</div>
                <div class="ch_title">
                  <div class="dataListTitle">{{ item.title }}</div>
                  <div class="subTitle">{{ item.subtitle }}</div>
                </div>
              </div>
              <ul class="data-list">
                <li
                  v-for="(dataItem, dataIndex) in item.dataList"
                  :key="dataIndex"
                  class="data-list-item"
                  @click="clickDate(dataItem, index)"
                >
                  <div class="data-list-left">
                    <div class="content-time">{{ dataItem.time }}</div>
                    <div class="data-title">
                      {{ dataItem.title }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="appointment-demonstration">
        <div class="content-center">
          <div class="appointment-demonstration-text">
            <h4 class="appointment-demonstration-title">
              了解更多有关华跃产品与服务信息
            </h4>
            <h5 class="appointment-demonstration-subtitle">
              您还可以预约我们的产品演示
            </h5>
          </div>
          <div class="appointment-demonstration-btn" @click="openBealter">
            <span>预约产品显示</span>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail, download } from '@/api/content';
export default {
  name: 'AchievementView',
  data() {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/achievements/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      valueIndex: null,
      topNaviId: null,
      navList: [
        {
          title: '产品价值',
          id: 'product-value',
        },
        {
          title: '系统架构',
          id: 'architecture',
        },
        {
          title: '功能介绍',
          id: 'introduction',
        },
        {
          title: '数据安全',
          id: 'data-security',
        },
        {
          title: '客户案例',
          id: 'customer-stories',
        },
        {
          title: '资料下载',
          id: 'data-download',
        },
      ],
      valueList: [
        // {
        //   icon: value1,
        //   title: '多种绩效模式',
        //   describeList: [
        //     '提供含KPI、360、OKR等多种绩效模式',
        //     '建立标准化的绩效管理流程',
        //     '减少人为干预因素，实现绩效管理制度快速落地',
        //   ],
        // },
      ],
      architecture: '',
      introductionTagList: [
        // {
        //   text: '目标分解',
        //   index: 0,
        // },
      ],
      introductionIndex: 0,
      introductionList: [
        // {
        //   title: '绩效指标无法有效的与团队和公司目标结合',
        //   img: require('@/assets/achievements/introduction1.png'),
        //   content: [
        //     '将公司经营目标通过逻辑关系与各个部门目标建立联系',
        //     '部门目标用同样的方式实现与关键岗位指标关联',
        //     '所有逻辑关系可以通过可视化的设置灵活调整',
        //   ],
        // },
      ],
      dataDownloadList: [
        {
          title: '资料下载',
          eng: 'DOWNLOAD',
          subtitle: '行业资料下载',
          img: require('@/assets/achievements/dataDownload1.png'),
          dataList: [],
        },
        {
          title: '产品动态',
          eng: 'PRODUCT NEWS',
          subtitle: '产品更新动态',
          img: require('@/assets/achievements/dataDownload2.png'),
          dataList: [],
        },
        {
          title: '干货推荐',
          eng: 'INDUSTRY KNOWLEDGE',
          subtitle: '行业硬知识',
          img: require('@/assets/achievements/dataDownload3.png'),
          dataList: [],
        },
      ],
      dataSecurityTagList: [
        // {
        //   title: '身份认证',
        //   url: require('@/assets/personnelgrow/icon/data-security-tag1.png'),
        //   index: 0,
        // },
      ],
      dataSecurityList: [
        // {
        //   url: require('@/assets/personnelgrow/data-security-img1.png'),
        //   textList: [
        //     '传统用户名/密码认证1',
        //     '支持动态密码安全认证方式',
        //     '支持USBE-key电子密钥安全认证方式(CA)',
        //   ],
        // },
      ],
      dataSecurityTagActiveIndex: 0,

      enterpriseList: [],
    };
  },
  watch: {
    scrollTop(newValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop =
              this.$refs[`${this.navList[i].id}`].offsetTop -
              this.scrollTop -
              1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
    this.getPartner();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = offsetHeight / 2 + 70 + 'px';
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    getPageColumn() {
      const params = { parentId: '1605836054676594688', };
      getColumnChild(params).then(async (res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '产品价值') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var valueItem = {
                  title: rrsult.data[j].title,
                  icon: rrsult.data[j].icon,
                  describeList: [],
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                for (var x = 0; x < rtsult.elements.length; x++) {
                  valueItem.describeList.push(rtsult.elements[x].content);
                }
                this.valueList.push(valueItem);
              }
            });
          } else if (result[i].name === '系统架构') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              this.architecture = rrsult.icon;
            });
          } else if (result[i].name === '功能介绍') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var introductionTag = {
                  text: rrsult.data[j].title,
                  index: j,
                };
                this.introductionTagList.push(introductionTag);
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var introductionItem = {
                  title: rtsult.title,
                  img: rtsult.icon,
                  content: [],
                };
                for (var x = 0; x < rtsult.elements.length; x++) {
                  introductionItem.content.push(rtsult.elements[x].content);
                }
                this.introductionList.push(introductionItem);
              }
            });
          } else if (result[i].name === '数据安全') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var dataSecurityTag = {
                  title: rrsult.data[j].title,
                  url: rrsult.data[j].icon,
                  index: j,
                };
                this.dataSecurityTagList.push(dataSecurityTag);
                var rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var dataSecurityItem = {
                  url: rtsult.logo,
                  textList: [],
                };
                for (var x = 0; x < rtsult.elements.length; x++) {
                  dataSecurityItem.textList.push(rtsult.elements[x].content);
                }
                this.dataSecurityList.push(dataSecurityItem);
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
      const downLoadParams = { columnId: '1605494229646401536', pageNum: 1, pageSize: 4, commendation: 14, cascade: true, };
      getContentList(downLoadParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[0].dataList = result.data;
      });
      const contentParams = { columnId: '1605774350588534784', pageNum: 1, pageSize: 4, commendation: 14, };
      getContentList(contentParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[1].dataList = result.data;
      });
      const industryParams = { columnId: '1605774444985540608', pageNum: 1, pageSize: 4, commendation: 14, };
      getContentList(industryParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[2].dataList = result.data;
      });
    },

    // 合作伙伴列表
    getPartner() {
      var params = { columnId: '1605405080163672064', pageNum: 1, pageSize: 18, commendation: 16, cascade: true, };
      getContentList(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.data.length; i++) {
          this.enterpriseList.push(result.data[i].logo);
        }
      });
    },

    clickDate(data, index) {
      if (index === 0) {
        getContentDetail(data.id).then((res) => {
          const { result, } = res;
          var file = result.elements.find(obj => obj.name === 'file').content;
          download(file[0].url).then((rrs) => {
            const fileName = file[0].name;
            const blob = new Blob([ rrs.data, ]);
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              // 兼容window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(fileName));
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob);
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement('a');
              tempLink.style.display = 'block';
              tempLink.href = blobURL;
              tempLink.setAttribute('download', decodeURI(fileName));
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank');
              }
              // 挂载a标签
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL);
            }
          });
        });
      } else if (index === 1) {
        this.$router.push({ path: `/news/details/${data.id}`, query: { type: 1, }, });
      } else if (index === 2) {
        this.$router.push({ path: `/news/details/${data.id}`, query: { type: 2, }, });
      }
    },

    onMouseenter(i) {
      this.valueIndex = i;
    },
    onMouseleve() {
      this.valueIndex = null;
    },
    changeStep(index) {
      this.dataSecurityTagActiveIndex = index;
    },
    changeIntroduction(index) {
      this.introductionTagActiveIndex = index;
    },
    changeIndex(i) {
      this.introductionIndex = i.index;
    },
    last() {
      if (this.dataSecurityTagActiveIndex !== 0) {
        this.dataSecurityTagActiveIndex -= 1;
      }
    },
    next() {
      if (this.dataSecurityTagActiveIndex !== 2) {
        this.dataSecurityTagActiveIndex += 1;
      }
    },
    moreEnterprise () {
      this.$router.push({ name: 'CustomerCase', });
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang='less' scoped>
.achievements {
  background-color: #fff;
  .page-content {
    width: 100%;
    .achievements-canvas {
      width: 100%;
      height: fit-content;
      min-width: var(--minwidth);
      position: relative;
      background-size: cover;
      overflow: hidden;
      .achievements-background {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        // width: 100%;
        // height: 560px;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // object-fit: cover;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
        }
      }
      .por-container {
          width: 85%;
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          .solution-info {
            width: 540px;
            height: 560px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            box-sizing: border-box;
            .solution-info-title {
              font-size: 45px;
              font-weight: bold;
              line-height: 55px;
              color: #181818;
              margin-bottom: 30px;
            }
            .solution-info-content {
              font-size: 20px;
              line-height: 32px;
              color: #7b7b7b;
              margin-bottom: 44px;
            }
            .solution-btn {
              width: 142px;
              height: 48px;
              background-color: #00b0dc;
              color: #fff;
              text-align: center;
              line-height: 48px;
              cursor: pointer;
              border-radius: 24px;
            }
          }
        }
    }
    .achievements-nav {
      width: 100%;
      display: flex;
      position: relative;
      justify-content: center;
      z-index: 50;
      .achievements-nav-tabs {
        margin: 0 auto;
        box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
        border-radius: 2px;
        background-color: #fff;
        display: flex;
        position: absolute;
        top: -26px;
        .achievements-nav-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .achievements-nav-item:hover {
          color: #00b0dc;
        }
        .top-nav-item {
          color: #ffffff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
      }
    }
    .product-value {
      width: 1200px;
      padding-top: 116px;
      margin: 0 auto;
      background-color: #fff;
      box-sizing: border-box;
      .title-subtitle {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 64px;
        .title {
          font-size: 32px;
          color: #181818;
          line-height: 1;
        }
      }
      .value-list {
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 0 auto;
        .value-list-item {
          width: calc(50% - 34px);
          height: 187px;
          margin: 15px;
          background-color: #ffffff;
          border: 1px solid #dddddd;
          border-radius: 8px;
          .value-list-item-card {
            width: 100%;
            color: #181818;
            height: 100%;
            padding: 16px;
            transition: all 0.3s ease-in-out;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .list-item-icon-wrap {
              width: 44px;
              height: 44px;
              background-color: #ebf9fc;
              border-radius: 8px;
              display: flex;
              justify-content: center;
              align-items: center;
              .list-item-icon {
                width: 18px;
                height: auto;
                opacity: 1;
                display: block;
              }
            }
            .list-item-text {
              flex: 1;
              margin-left: 17px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .list-item-title {
                margin-top: 7px;
                font-size: 18px;
                font-weight: bold;
                line-height: 1;
                color: #181818;
              }
              .list-item-des {
                width: 100%;
                flex: 1;
                margin-top: 18px;
                .list-item-des-item{
                  color: #757575;
                  font-size: 16px;
                  line-height: 25px;
                }
              }
            }
          }
        }
      }
    }
    .architecture{
      width: 1200px ;
      // min-width: var(--minwidth);
      padding-top: 119px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .architecture-content{
        width: 100%;
        img{
          width: 100%;
        }
      }
    }
    .introduction{
      width: 100%;
      padding-top: 109px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        padding-bottom: 70px;
        box-sizing: border-box;
      }
      .introduction-tag-list{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        .tag-list-item{
          flex: 1;
          display: flex;
          justify-content: center;
          .tag-list-text{
            font-size: 20px;
            color: #181818;
            line-height: 63px;
            cursor: pointer;
            border-bottom: 6px solid transparent;
          }
          .tag-list-text:hover{
            font-weight: 600;
            border-bottom: 6px solid #00b0dc;
          }
        }
        .tag-list-item-change{
          .tag-list-text{
            font-weight: 600;
            border-bottom: 6px solid #00b0dc;
          }
        }
      }
      .introduction-content-box{
        width: 100%;
        background-color: #f8fbff;
        padding: 80px 0 60px;
        .introduction-content{
          width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .introduction-content-left{
            width: 420px;
            padding-top: 80px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            .content-title{
              width: 362px;
              font-size: 28px;
              font-weight: 600;
              color: #181818;
              margin-bottom: 30px;
            }
            .content-text-box{
              display: flex;
              align-items: flex-start;
              justify-content: flex-start;
              margin-bottom: 17px;
              .content-text-li{
                width: 6px;
                height: 6px;
                background-color: #c8defe;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 9px;
              }
              .content-text{
                flex: 1;
                font-size: 16px;
                color: #314666;
              }
            }
          }
          .introduction-content-right{
            width: 740px;
            height: 460px;
            img{
              width: 100%;
              height: auto;
              display: block;
            }
          }
        }
        .introduction-contents-enter-active{
          animation: bounce-in 0.3s;
        }
        .introduction-contents-leave-active{
          animation: bounce-in 0 reverse;
        }
        @keyframes bounce-in {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }
    }
    .data-download{
      width: 1200px;
      padding-top: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 100px;
      .title{
        font-size: 32px;
        color: #181818;
      }
      .data-download-content{
        display: flex;
        margin: 70px auto 0;
        .data-download-content-item{
          width: 380px;
          height: 330px;
          margin-right: 30px;
          box-sizing: border-box;
          border: 1px solid #ddd;
          background-color: #fff;
          border-radius: 8px;
          .item-title-box{
            width: 100%;
            height: 168px;
            padding: 29px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            position: relative;
            .background{
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              display: block;
              width: 100%;
              height: auto;
            }
            .eng_title{
              font-size: 12px;
              opacity: 0.8;
              color: #fff;
              line-height: 1;
            }
            .ch_title{
              display: flex;
              align-items: center;
              justify-content: flex-start;
              z-index: 99;
              margin-top: 16px;
              .dataListTitle{
                font-size: 18px;
                color: #fff;
                line-height: 1;
                font-weight: bold;
                padding-right: 9px;
                border-right: 2px solid #ffffff;
              }
              .subTitle{
                padding-left: 10px;
                line-height: 1;
                font-size: 18px;
                color: #ffffff;
              }
            }
          }
          .data-list{
            width: 100%;
            padding: 14px 30px 0 30px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            .data-list-item{
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin-top: 14px;
              box-sizing: border-box;
              list-style:disc;
              .data-list-left{
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .content-time{
                  color: #6d717c;
                  font-size: 12px;

                }
                .data-title{
                  width: 260px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  font-size: 14px;
                  color: #181818;
                  cursor: pointer;
                  position: relative;
                  margin-left: 15px;
                }
              }
            }
            .data-list-item:hover{
              .data-list-left{
                .disc{
                  background-color: #00b0dc;
                }
                .data-title{
                  color: #00b0dc;
                }
              }
              .data-list-right{
                display: block;
              }
            }
          }
        }
        .data-download-content-item:last-child{
          margin-right: 0;
        }
      }
    }
    .data-security {
      width: 1200px;
      // min-width: var(--minwidth);
      padding-top: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title {
        font-size: 32px;
        color: #181818;
        margin-bottom: 70px;
      }
      .data-security-tag {
        display: flex;
        align-items: center;
        margin-bottom: 60px;
        .data-security-tag-item {
          display: flex;
          align-items: center;
          cursor: pointer;
          .item-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            .item-icon {
              width: 62px;
              height: 62px;
              background-color: transparent;
              border: 1px solid transparent;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-bottom: 23px;
            }
            .item-icon-active {
              background-color: #fff;
              border: 1px solid #00b0dc;
              box-shadow: 0px 8px 20px 0px rgba(69, 125, 177, 0.12);
            }
            .item-title {
              font-size: 18px;
              color: #181818;
            }
          }
          .data-security-tag-arrow {
            width: 192px;
            height: 1px;
            background-color: #e1e6f0;
            margin: 0 28px;
            margin-bottom: 46px;
          }
        }
      }
      .data-security-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .arrow {
          width: 24px;
          height: 24px;
          box-shadow: 0px 8px 20px 0px rgba(75, 75, 137, 0.1);
          cursor: pointer;
          img {
            display: block;
          }
        }
        .data-security-content-list {
          height: 252px;
          display: flex;
          justify-content: center;
          align-items: center;
          .data-security-content-left {
            width: 355px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              display: block;
            }
          }
          .data-security-content-right {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            margin-left: 145px;
            .content-text-box {
              display: flex;
              justify-content: center;
              align-items: flex-start;
              .list-icon {
                width: 16px;
                height: 16px;
                margin-top: 1px;
                margin-right: 12px;
              }
              .text {
                font-size: 16px;
                color: #7b7b7b;
                line-height: 1;
                padding-bottom: 30px;
              }
            }
          }
        }
      }
      // .secrity-fade-enter-active {
      //   animation: bounc-in 1.3s;
      // }
      // .secrity-fade-lave-active {
      //   animation: bounce-in 0.5s reverse;
      // }
      // @keyframes bounce-in {
      //   0% {
      //     opacity: 0;
      //   }
      //   100% {
      //     opacity: 0;
      //   }
      // }
    }
    .customer-stories{
      width: 100%;
      min-width: 1200px;
      display: flex;
      flex-direction: column;
      background: url('@/assets/staffmanage/customer-back.png') no-repeat;
      background-position: center;
      background-size: cover;
      background-position: center;
      height: 561px;
      padding: 69px 0 60px;
      box-sizing: border-box;
      .customer-stories-content{
        width: 80%;
        min-width: var(--minwidth);
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 32px;
          font-weight: 500;
          color: #181818;
          margin-bottom: 70px;
        }
        .customer-stories-list{
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          .cystiner-stirues-item{
            width: calc(16.666% - 20px);
            height: 70px;
            margin: 10px;
            background-color: #fff;
            border: solid 1px #dfdfdf;
            display: flex;
            box-sizing: border-box;
            justify-content: center;
            align-items: center;
            padding: 10px;
            img{
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
            }
          }
        }
        .customer-stories-btn{
          width: 155px;
          height: 50px;
          background-color: #00b0dc;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          cursor: pointer;
          .btn-text{
            font-size: 15px;
            color: #ffffff;
          }
          &:hover{
            transform: scale(1.1);
            transition: all  0.5s;
          }
        }
      }
    }
    .appointment-demonstration {
      width: 100%;
      height: 126px;
      background-image: url('@/assets/personnelgrow/appointment-demonstration.png');
      background-repeat: no-repeat;
      background-size: cover;
      color: #fff;
      // padding: 22px;
      box-sizing: border-box;
      .content-center {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .appointment-demonstration-text {
          .appointment-demonstration-title {
            font-size: 22px;
            color: #fff;
            font-weight: 500;
            margin-bottom: 16px;
            line-height: 1;
          }
          .appointment-demonstration-subtitle {
            font-size: 16px;
            font-weight: 400;
            color: #fff;
            line-height: 1;
          }
        }
        .appointment-demonstration-btn {
          width: 124px;
          height: 42px;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          border: 1px solid #fff;
          line-height: 42px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          // img{
          //   width: 18px;
          //   height: 42px;
          //   vertical-align: middle;
          // }
          transition: all 0.5s;
          // &:hover{
          //   transform: scale(1.1);
          //   transition: all  0.5s;
          // }
        }
      }
    }
  }
}
</style>
